import { GET_INFORMACION_GUIA, GET_MENSAJES, READ_NOTIFICACION, PERMISOS_NOTIFICACION } from './Actions';
import { IGuia } from "../interface/IGuia";
import { IMensaje } from '../interface/IMensaje';



export const getInformacionGuia = (guia:IGuia) => (
    {
    type: GET_INFORMACION_GUIA,
    guia
})
export const getMensajes = (mensajes:IMensaje[]) => (
    {
    type: GET_MENSAJES,
    mensajes
})
export const readNotifiaciones = (guia:string,numeroNotifiaciones:number) => (
    {
    type: READ_NOTIFICACION,
    guia,
    numeroNotifiaciones
})
export const permisosNotifiaciones = (permitido:boolean) => (
    {
    type: PERMISOS_NOTIFICACION,
    permitido
})
